import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TiersService, RestaurantService, ChangesetService, ConceptService, CategoryService } from './services';
import {
  ConfigurationComponent,
  DeliveryPriceMessageComponent,
} from './components';
import { BaseModule } from '../shared/base.module';
@NgModule({
  exports: [ConfigurationComponent, DeliveryPriceMessageComponent],
  declarations: [ConfigurationComponent, DeliveryPriceMessageComponent],
  imports: [CommonModule, BaseModule],
  providers: [RestaurantService, TiersService, ChangesetService, ConceptService, CategoryService],
})
export class SharedDataModule {}
